export const ACTION_ATTACK = 'ACTION_ATTACK'
export const ACTION_MOVE = 'ACTION_MOVE'
export const ACTION_REST = 'ACTION_REST'

export const BOARD_HEIGHT = 11
export const BOARD_WIDTH = 11

export const COMBAT_DISTANCE_MELEE  = 1
export const COMBAT_DISTANCE_RANGED  = 12

export const DIRECTION_DOWN = 'Down'
export const DIRECTION_LEFT = 'Left'
export const DIRECTION_RIGHT = 'Right'
export const DIRECTION_UP = 'Up'
export const ALL_DIRECTIONS = [
    DIRECTION_LEFT, 
    DIRECTION_RIGHT, 
    DIRECTION_UP, 
    DIRECTION_DOWN
]

export const ENTITY_TYPE_CHARACTER = 'ENTITY_TYPE_CHARACTER'
export const ENTITY_TYPE_TERRAIN = 'ENTITY_TYPE_TERRAIN'

export const TERRAIN_PLAIN = 0
export const TERRAIN_TREE = 1
export const TERRAIN_ROCK = 2
export const TERRAIN_WATER = 3

export const WEAPON_BOW = 'WEAPON_BOW'
export const WEAPON_CLAWS = 'WEAPON_CLAWS'
export const WEAPON_SPIT = 'WEAPON_SPIT'
export const WEAPON_SWORD = 'WEAPON_SWORD'